const SET_CONFIG = 'SET_CONFIG';

const setConfig = config => ({
  type: SET_CONFIG,
  payload: {
    ...config
  }
});

export { SET_CONFIG, setConfig };
